import { useEffect, useRef } from 'react';

// evs.com식 스크롤 리빌: 뷰포트 진입 시 .is-inview 부여
export function useReveal<T extends HTMLElement = HTMLDivElement>() {
  const ref = useRef<T | null>(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    // [2026-10-11 사용자] 초기 진입 시 뷰포트에 '이미 걸친' 요소(히어로 바로 아래 첫 섹션 등)는 스크롤 없이 즉시 노출.
    //   WHY: 72vh 히어로 아래 첫 섹션이 opacity:0 reveal이라 최초 화면이 비어 보이던 UX 문제. 뷰포트 밖 요소만 스크롤 리빌 유지.
    if (el.getBoundingClientRect().top < window.innerHeight * 0.96) {
      el.classList.add('is-inview');
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('is-inview');
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' },
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);
  return ref;
}
